import { render, staticRenderFns } from "./DashboardTokenOptions.vue?vue&type=template&id=1224f352&scoped=true&"
import script from "./DashboardTokenOptions.vue?vue&type=script&lang=js&"
export * from "./DashboardTokenOptions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTokenOptions.vue?vue&type=style&index=0&id=1224f352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224f352",
  null
  
)

export default component.exports